import React from "react";
import { motion } from "framer-motion";

const GradientLine = ({ color = "brand-blue" }) => {
  const isWhite = color === "white";

  return (
    <motion.div
      initial={{ opacity: 0, scaleX: 0 }}
      whileInView={{ opacity: 1, scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className="w-full flex justify-center overflow-hidden"
    >
      <div
        className={`relative w-full max-w-[80%] h-px ${
          isWhite
            ? "bg-linear-to-r from-transparent via-white to-transparent"
            : "bg-linear-to-r from-transparent via-brand-blue to-transparent"
        }`}
      >
        <div
          className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-12 blur-2xl ${
            isWhite ? "bg-white opacity-80" : "bg-brand-blue opacity-20"
          }`}
        />
      </div>
    </motion.div>
  );
};

export default GradientLine;
